import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import './styles.sass';

const useStyles = makeStyles({
    text: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
        }
    },
    stage: {
        '&&': {
            fontWeight: 'bold'
        }
    }
});

const DirectionBox = ({ index, value, size }) => {
    const classes = useStyles();

    return (
        <div className="direction-container">
            <div className="step-wrapper">
                <div className="circle" />
                {index !== (size - 1) &&
                    <div className="dash" />
                }
            </div>
            <div>
                <Typography
                    variant='h6'
                    className={clsx(classes.text, classes.stage)}>
                    שלב {index + 1}
                </Typography>
                <Typography
                    variant='subtitle1'
                    gutterBottom
                    className={classes.text}
                >
                    {value}
                </Typography>
            </div>
        </div>
    )
}

export default DirectionBox;